import { html, nothing, render } from "lit-html";
import { count, onChangeHotels } from "../../state/FavoriteHotels";
import { translate } from "@escapio/shared/l10n/translate";
import { data } from "@escapio/shared/state/payload";
import { classMap } from "lit-html/directives/class-map.js";

class FavoritesLink extends HTMLElement {
	connectedCallback() {
		onChangeHotels(() => this.render());
		this.render();
	}

	render() {
		const favoritesCount = count();
		const template = html`
			<a
				href=${data.uris.favorites}
				class="${classMap({
					"favorites-link": true,
					[this.additionalClasses]: true,
				})}"
				aria-label=${translate("list_favorites_search_panel_query")}
			>
				<span>
					<span class="fa fa-heart-o"></span>${favoritesCount &&
					!this.hideCounter
						? html`<span
								class="header-menu__item__icon-addon
								counter-badge
								counter-badge--size-tiny
								${classMap({
									"counter-badge--gray": !this.hasBlackBadge,
									"counter-badge--black": this.hasBlackBadge,
								})}
								"
								>${favoritesCount}</span
							>`
						: nothing}</span
				><span
					class="menu-item__label ${classMap({
						"hidden-mobile": !this.hasAttribute("always-with-title"),
					})}"
					>${translate("header_favorites_title")}</span
				>
			</a>
		`;
		render(template, this, { host: this });
	}

	get additionalClasses() {
		return this.getAttribute("additional-classes") || "";
	}

	get hasBlackBadge() {
		return this.hasAttribute("black-badge");
	}

	get hideCounter() {
		return this.hasAttribute("hide-counter");
	}
}
customElements.define("esc-favorites-link", FavoritesLink);
